import React from 'react';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import environmentStore from '@di-shared/features/environment/environmentStore';
import VehicleInspectionAddVehicle from '@di-shared/features/public-service/vehicle-inspection/VehicleInspectionAddVehicle';

function VehicleInspectionAddVehiclePage() {
  const {t} = useInferableTranslation();
  const puid = environmentStore.getState().puid;
  return (
    <div className="wrap">
      <Header right={<HeaderCloseButton />}>
        <h1 className="headline_xxsmall nav_center_title">{t('T30492')}</h1>
      </Header>
      <VehicleInspectionAddVehicle puid={puid} />
    </div>
  );
}

export default VehicleInspectionAddVehiclePage;
